import React from 'react';
import { useTranslation } from 'react-i18next';

const NoProductsData = ({ onClickAddProductUrl, onClickAddProductList, hideAddFromList }) => {
  const { t } = useTranslation();
  return (
    <div className='text-center my-70'>
      <p>{t('no_product_in_project')}</p>
      <div className='mt-16'>
        <button className='btn btn-outline-primary mx-8 mb-5 mb-md-0' onClick={onClickAddProductUrl}>
          {t('btn_add_product_url')}
        </button>
        {!hideAddFromList && (
          <button className='btn btn-primary mx-8 d-none d-md-inline' onClick={onClickAddProductList}>
            {t('btn_add_from_list')}
          </button>
        )}
      </div>
    </div>
  );
};

export default NoProductsData;
